import { debounce } from 'throttle-debounce';
import UrlGeneration from '@lovata/url-generation/url-generation';
import Filter from './filter';
import ionRangeSlider from '../../assets/src/js/rangeslider';

const debounceFunc = debounce(1500, () => {
    document.querySelector('input[data-type="min"]').value = document.querySelector('input[data-type="min"]').getAttribute('placeholder');
    document.querySelector('input[data-type="max"]').value = document.querySelector('input[data-type="max"]').getAttribute('placeholder');

    UrlGeneration.init();
    UrlGeneration.set('price', document.querySelector('input[data-type="min"]').value + '|' + document.querySelector('input[data-type="max"]').value);
    UrlGeneration.update();

    Filter.filteredProduct();
});

document.querySelectorAll('._js-range-slider').forEach(function (slider) {
    ionRangeSlider(slider, {
        skin: "big",

        onChange(data) {
            document.querySelector('input[data-type="min"]').setAttribute('placeholder', data.from);
            document.querySelector('input[data-type="max"]').setAttribute('placeholder', data.to);
        },
        onFinish(data) {
            debounceFunc();
        },
    });
});